import React from 'react';

export class NoFilter extends React.Component {
    render() { return <React.Fragment/>; }
}